const baseUrl = process.env.NEXT_PUBLIC_BASE_URL;
const CMS_URL = `${baseUrl ? baseUrl : 'https://designic.com'}/wp-json/api/v1/content/`;

export default async function cmsClient(
  endpoint: string,
  options: RequestInit = {},
  params?: Record<string, string | number | boolean>
) {
  const username = process.env.CMS_USER || "designic"
  const password = process.env.CMS_PASS || "d3s1gn1c"
  const basicAuth = Buffer.from(`${username}:${password}`).toString("base64")

  // build query string if params provided
  const queryString = params
    ? "?" + new URLSearchParams(params as Record<string, string>).toString()
    : ""

  // always normalize URL to avoid missing/double slashes
  const url = `${CMS_URL.replace(/\/$/, "")}/${endpoint.replace(/^\//, "")}${queryString}`

  const res = await fetch(url, {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Basic ${basicAuth}`,
      ...(options.headers || {}),
    },
    ...options,
  })

  if (!res.ok) {
    throw new Error(`CMS error: ${res.status} ${res.statusText}`)
  }

  const text = await res.text()

  if (!text) {
    return []
  }

  try {
    return JSON.parse(text)
  } catch (err) {
    console.error("Failed to parse CMS response:", text)
    throw err
  }
}
